
<nav class="stepper" aria-label="Progress" *ngIf="showStepper()">
  <button
    class="step"
    *ngFor="let s of steps; let i = index"
    [class.completed]="statusOf(i)==='completed'"
    [class.active]="statusOf(i)==='active'"
    [class.pending]="statusOf(i)==='pending'"
    (click)="goTo(i)"
    [disabled]="!canNavigateTo(i)"
    [attr.aria-current]="statusOf(i)==='active' ? 'step' : null"
    [attr.aria-disabled]="!canNavigateTo(i)"
  >
    <span class="circle" aria-hidden="true">
      <span *ngIf="statusOf(i)==='completed'" class="check">✓</span>
      <span *ngIf="statusOf(i)!=='completed'" class="index">{{ i + 1 }}</span>
    </span>
    <span class="label">{{ s.label }}</span>
  </button>
</nav>
